module.exports = __webpack_public_path__ + "assets/img/bundesliga-01042023-competition-final.webp?ad2b63ad5294cb044ad71f87bdda5a86";